import { useGetRoles, usePermissions } from '@dispatch/shared/hooks';
import { RolesListFilter } from '@dispatch/shared/types';
import { Roles } from '@dispatch/web/features/roles';
import { isEmpty } from 'lodash';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useDebounce } from 'react-use';

const RolesPage = () => {
  const defaultFilters: RolesListFilter = {
    pageSize: 10,
  };
  const [filters, setFilters] = React.useState<RolesListFilter>(defaultFilters);
  const [debouncedFilters, setDebouncedFilters] = React.useState<{
    filters: RolesListFilter;
  }>({ filters: {} as RolesListFilter });

  useDebounce(() => setDebouncedFilters({ filters }), 500, [filters]);

  const rolesData = useGetRoles(
    debouncedFilters.filters,
    !isEmpty(debouncedFilters.filters)
  );
  const { permissions } = usePermissions();
  const onSearch = (value: string) => {
    setFilters({ ...filters, roleName: value });
    rolesData?.goToFirstPage();
  };

  return (
    <>
      <Roles
        status={rolesData.status}
        rolesData={rolesData}
        onSearch={onSearch}
        onFilterChange={setFilters}
        filters={filters}
        permissions={permissions}
      />
      <Outlet context={{ refetch: rolesData.fetchCurrentPage }} />
    </>
  );
};

export default RolesPage;
